// src/apiConfig.js
export const API_BASE =
  "https://us-central1-lehameaudusorbier.cloudfunctions.net";

export const ADMIN_KEY = "DEV_SECRET_CHANGE_MOI";

export const ICS_FEED_URL =
  "https://us-central1-lehameaudusorbier.cloudfunctions.net/exportICS";


  export const MAISON_TXT_URL =
  "https://us-central1-lehameaudusorbier.cloudfunctions.net/getMaisonTxt";
